import React, { useEffect, useState } from "react";
import CustomEditCard from "../../../../common/components/CustomEditCard/CustomEditCard";
import CardContentTile from "../../../../common/components/CardContentTile/CardContentTile";
import { emergencyContactType } from "../../../../common/interfaces/myProfile/personalDetails/emergencyContactType";
import { Box } from "@mui/system";
import EmergencyContactModalController from "../../../../common/Modals/PersonalDetails/EmergencyContact/EmergencyContactModalController";
import { themes } from "../../../../common/themes/themes";

interface propsType {
  emergencyData: emergencyContactType;
  isCardUpdate: (data: boolean) => void;
  hr_view?: boolean;
  trans?: any;
}
const EmergencyContactPresenter: React.FC<propsType> = ({
  emergencyData,
  isCardUpdate,
  hr_view,
  trans,
}) => {
  const callBackCardUpdate = (cardUpdate: boolean) => {
    isCardUpdate(cardUpdate);
  };
  const [openModal, setOpenModal] = useState(false);
  return (
    <div>
      <CustomEditCard
        card_title={trans("Emergency Contact")}
        card_height="388px"
        onClick={() => setOpenModal(true)}
        showEditButton={true}
      >
        <Box style={{ marginBottom: "24px" }} />
        <CardContentTile
          tile_key={trans("Name")}
          tile_value={emergencyData?.emergencyPersonName}
        />
        <CardContentTile
          tile_key={trans("Relationship")}
          tile_value={emergencyData?.emergencyRelationship}
        />
        <CardContentTile
          tile_key={trans("Email")}
          tile_value={emergencyData?.emergencyEmail}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans("Phone")}
          tile_value={emergencyData?.emergencyContactNumber?.toString()}
          value_color={themes.defaultInfoBlue}
        />
        <CardContentTile
          tile_key={trans("Country")}
          tile_value={emergencyData?.emergencyCountry}
        />
      </CustomEditCard>

      {/* Emergency Contact Info Modal */}

      {openModal && (
        <EmergencyContactModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          isCardUpdate={callBackCardUpdate}
          trans={trans}
        />
      )}
    </div>
  );
};

export default EmergencyContactPresenter;
